import { createApp } from 'vue'
import { createPinia } from 'pinia'
import VueGtag from 'vue-gtag'
import router from './router'
import App from './App.vue'
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'
import './assets/css/main.css'

// トップページ（/）では静的HTMLランディングページを表示
// 特定の公開ページ（/commerce等）では専用コンポーネントを表示
// 他のページでは Vue.js アプリをマウント
const landingPage = document.getElementById('landing-page')
const vueApp = document.getElementById('app')

if (window.location.pathname === '/') {
  // ランディングページを表示、Vue.jsアプリは非表示
  landingPage.style.display = 'block'
  vueApp.style.display = 'none'
} else if (window.location.pathname === '/commerce') {
  // 特定商取引法ページを表示
  landingPage.style.display = 'none'
  vueApp.style.display = 'block'
  
  import('./views/CommercePage.vue').then((module) => {
    const app = createApp(module.default)
    app.use(VueGtag, {
      config: {
        id: 'G-NPSB35XHYS'
      }
    })
    app.mount('#app')
  })
} else {
  // ランディングページを非表示、Vue.jsアプリをマウント
  landingPage.style.display = 'none'
  vueApp.style.display = 'block'

  const app = createApp(App)

  app.use(createPinia())
  app.use(router)
  app.use(VueGtag, {
    config: {
      id: 'G-NPSB35XHYS'
    }
  }, router)
  app.use(Toast, {
    position: 'top-right',
    timeout: 5000,
    closeOnClick: true,
    pauseOnFocusLoss: true,
    pauseOnHover: true,
    draggable: true,
    draggablePercent: 0.6,
    showCloseButtonOnHover: false,
    hideProgressBar: false,
    closeButton: 'button',
    icon: true,
    rtl: false
  })

  app.mount('#app')
}
